<template>
  <el-container :style="parent" class="parent">
    <el-header>产品信息查询</el-header>
    <el-main>
      <el-row>
        <el-col :span="14">
          <el-form ref="form" :model="form" label-width="140px" class="mainform" @submit.native.prevent>
            <el-form-item label="请输入查询的码:">
              <el-input clearable type="text" v-model="form.qrcode"
                @keyup.native.enter="handleDialogSelectRoom()"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8" :offset="1">
          <el-button type="primary" icon="el-icon-search" @click="formlistget"
            v-permission="['informationinquiry_select']">搜索</el-button>
        </el-col>
      </el-row>
      <br />
      <el-col :span="24">
        <!-- 第一次扫到正品码 -->
        <transition name="el-zoom-in-center">
          <el-card class="box-card" v-if="dialogVisible">
            <div slot="header" class="clearfix">
              <h3>产品详情</h3>
            </div>
            <el-form ref="formlist" :model="formlist" style="text-align: left; margin-bottom: 20px" class="mainform"
              center>
              <el-row>
                <el-col :span="6">
                  <el-card shadow="hover" class="fanwei">
                    <div slot="header" class="clearfix">
                      <h4>产品信息</h4>
                    </div>
                    <el-form-item label="生产批号:">
                      <div>{{ formlist.productInfo.batchNo }}</div>
                    </el-form-item>

                    <el-form-item label="产品编码:">
                      <div>{{ formlist.productInfo.productCode }}</div>
                    </el-form-item>
                    <el-form-item label="产品名称:">
                      <div>{{ formlist.productInfo.productName }}</div>
                    </el-form-item> <el-form-item label="规格:">
                      <div>{{ formlist.productInfo.specs }}</div>
                    </el-form-item>
                    <el-form-item label="保质期（天）:">
                      <div>{{ formlist.productInfo.qualityPeriod }}</div>
                    </el-form-item>
                    <el-form-item label="有效期:">
                      <div>{{ formlist.productInfo.periodDate }}</div>
                    </el-form-item>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="fanwei">
                    <div slot="header" class="clearfix">
                      <h4>生产信息</h4>
                    </div>
                    <el-form-item label="生产企业:">
                      <div>{{ formlist.produceInfo.enterpriseName }}</div>
                    </el-form-item>
                    <el-form-item label="订单号:">
                      <div>{{ formlist.produceInfo.orderNo }}</div>
                    </el-form-item>
                    <el-form-item label="产品工厂:">
                      <div>{{ formlist.produceInfo.factoryName }}</div>
                    </el-form-item>
                    <el-form-item label="生产线:">
                      <div>{{ formlist.produceInfo.workLineName }}</div>
                    </el-form-item>
                    <el-form-item label="生产时间:">
                      <div>{{ formlist.produceInfo.produceTime }}</div>
                    </el-form-item>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="fanwei">
                    <div slot="header" class="clearfix">
                      <h4>物流信息</h4>
                    </div>
                    <el-form-item label="配送物流">
                      <br />
                      <el-timeline :reverse="false">
                        <el-timeline-item v-for="(item, index) in formlist.flowVos" :key="index"
                          :timestamp="item.createTime">
                          <div>单号：{{ item.orderCode }}</div>
                          <div>物流类型：{{ item.orderType }}</div>
                          <div>发货方：{{ item.shipperName }}</div>
                          <div>发货地址：{{ item.shipperAddress }}</div>
                          <div>收货方：{{ item.shiptoName }}</div>
                          <div>收货地址：{{ item.shiptoAddress }}</div>
                        </el-timeline-item>
                      </el-timeline>
                    </el-form-item>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="fanwei">
                    <div slot="header" class="clearfix">
                      <h4>退货信息</h4>
                    </div>
                    <el-form-item label="配送物流">
                      <br />
                      <el-timeline :reverse="false">
                        <el-timeline-item v-for="(item, index) in formlist.returnInfos" :key="index"
                          :timestamp="item.createTime">
                          <div>出库单号：{{ item.outbillCode }}</div>
                          <div>退货单号：{{ item.returnOrderCode }}</div>
                          <div>客户编码：{{ item.dealerCode }}</div>
                          <div>客户名称：{{ item.dealerName }}</div>
                          <div>出库仓库：{{ item.warehouseCode }}-{{ item.warehouseName }}</div>
                          <div>发货时间：{{ item.outBillTime }}</div>

                          <div>退货仓库：{{ item.depositWarehouseCode }}-{{ item.depositWarehouseName }}</div>
                          <div>退回时间：{{ item.returnTime }}</div>

                        </el-timeline-item>
                      </el-timeline>
                    </el-form-item>
                  </el-card>
                </el-col>
              </el-row>
            </el-form>
            <el-form ref="formlist" :model="formlist" label-width="140px" v-show="formlist.hasInfo == false"
              class="mainform">
              <div>该产品不是官方正品！</div>
            </el-form>
          </el-card>
        </transition>
        <!-- 扫到假货 -->

      </el-col>
    </el-main>
    <!-- <el-footer><el-image :src="src"></el-image></el-footer> -->
  </el-container>
</template>
<script>
import { flowinfo, listtoken } from "@/api/physical";
import { qrcodecount } from "@/api/physical";
// import QRCode from "qrcodejs2";
export default {
  name: "home",
  data() {
    return {
      //接口参数
      form: {
        qrcode: "",
        packageLevel: null,
        pcquery: true, // 区分h5跟后台查询
      },
      formlist: {},
      logisticsinfo: [],
      // 全屏css
      parent: {
        height: "100%",
      },
      footer: {
        height: "200px",
      },
      // 基础数据
      dialogVisible: false,
      Visible: false,
      url: "https://www.baidu.com",
    };
  },
  mounted() { },

  methods: {
    // 转化码为二维码
    //     qrcodemk (obj) {
    //         document.getElementById("qrcode").innerHTML = "";// 清除上一个二维码
    //        let qrcode = new QRCode('qrcode',{
    //         width: 200, // 设置宽度，单位像素
    //         height: 200, // 设置高度，单位像素
    //         text: obj   // 设置二维码内容或跳转地址
    //     })
    // },
    // 跟据链接参数调接口
    formlistget() {
      if (this.form.qrcode == "") {
        this.$message({
          message: "请输入码",
          type: "warning",
        });
      } else {
        flowinfo({ qrcode: this.form.qrcode }).then((response) => {
          console.log(response)
          this.formlist = response.data;
          this.dialogVisible = response.data.hasInfo;
          for (let i = 0; i < this.formlist.flowVos.length; i++) {
            switch (this.formlist.flowVos[i].orderType) {
              case 1:
                this.formlist.flowVos[i].orderType = '工厂发货'
                break;
              case 2:
                this.formlist.flowVos[i].orderType = '经销商签收'
                break;
              case 3:
                this.formlist.flowVos[i].orderType = '经销商发货'
                break;
              case 4:
                this.formlist.flowVos[i].orderType = '终端签收'
                break;
              case 5:
                this.formlist.flowVos[i].orderType = '经销商退货'
                break;
              case 6:
                this.formlist.flowVos[i].orderType = '终端退货'
                break;
              case 7:
                this.formlist.flowVos[i].orderType = '生产入库'
                break;
              case 8:
                this.formlist.flowVos[i].orderType = '调拨出库'
                break;
            }

          }
        });
      }
    },
    // enter按下事件#a9a9a969
    handleDialogSelectRoom() {
      this.formlistget();
    },
  },
};
</script>
<style>
.fanwei {
  margin: 5px;
  height: 100%;
}

.el-card__header {
  background-color: #a9a9a969;
}
</style>
<style>
.parent .el-header {
  font-size: 20px;
  height: 50px !important;
  line-height: 50px;
  background-color: #03a9f4;
  color: aliceblue;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.parent .el-footer {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: auto !important;
  margin-bottom: 0px;
  padding: 0 0px;
}

.mainform .el-form-item,
.mainform .el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}
</style>